import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toastData = new BehaviorSubject<({severity: string, summary: string, detail: string})>({} as any)
  constructor (private _MessageService: MessageService) {} 
}